export var WEEK_HIGH_LOW = "WEEK_HIGH_LOW";
export var WEEK_HIGH_LOW_STREAM = "WEEK_HIGH_LOW_STREAM";
